import { defineMessages } from "react-intl";

export const billingReportMessages = defineMessages({
  title: {
    id: "billingReport.title",
    defaultMessage: "Billing report",
  },
  btnExport: {
    id: "billingReport.btnExport",
    defaultMessage: "Export CSV",
  },
  btnExportVariables: {
    id: "billingReport.btnExportVariables",
    defaultMessage: "Export variables CSV",
  },
  inputFilterPlaceholder: {
    id: "billingReport.inputFilterPlaceholder",
    defaultMessage: "Filter results",
  },
  errorMessage: {
    id: "billingReport.errorMessage",
    defaultMessage: "Some error occurred. Try again later.",
  },

  tableNoItems: {
    id: "billingReport.tableNoItems",
    defaultMessage: "Results are not found",
  },
  tableColumnInvoiceNumber: {
    id: "billingReport.table.column.invoiceNumber",
    defaultMessage: "Invoice number",
  },
  tableColumnIdMyS: {
    id: "billingReport.table.column.idMyS",
    defaultMessage: "Invoice number",
  },
  tableColumnTax: {
    id: "billingReport.table.column.tax",
    defaultMessage: "Invoice number",
  },
  tableColumnFP: {
    id: "billingReport.table.column.fp",
    defaultMessage: "Invoice number",
  },
  tableColumnLegalName: {
    id: "billingReport.table.column.legalName",
    defaultMessage: "Invoice number",
  },
  tableColumnCIF: {
    id: "billingReport.table.column.cif",
    defaultMessage: "Invoice number",
  },
  tableColumnDomain: {
    id: "billingReport.table.column.domain",
    defaultMessage: "Domain",
  },
  tableColumnPartner: {
    id: "billingReport.table.column.partner",
    defaultMessage: "Partner",
  },
  tableColumnConcept: {
    id: "billingReport.table.column.concept",
    defaultMessage: "Concept",
  },
  tableColumnPeriod: {
    id: "billingReport.table.column.period",
    defaultMessage: "Period",
  },
  unitPricePerClient: {
    id: "billingReport.table.column.unitPricePerClient",
    defaultMessage: "Unit price client",
  },
  tableColumnUnitPrice: {
    id: "billingReport.table.column.unitPrice",
    defaultMessage: "Unit price",
  },
  tableColumnUnits: {
    id: "billingReport.table.column.units",
    defaultMessage: "Units",
  },
  tableColumnRate: {
    id: "billingReport.table.column.rate",
    defaultMessage: "Rate",
  },
  tableColumnDiscount: {
    id: "billingReport.table.column.discount",
    defaultMessage: "Disc.",
  },
  tableColumnTotalRate: {
    id: "billingReport.table.column.totalRate",
    defaultMessage: "Total rate",
  },
  tableColumnCurrency: {
    id: "billingReport.table.column.currency",
    defaultMessage: "Cur. Contract",
  },
  tableColumnCurrencyChange: {
    id: "billingReport.table.column.currencyChange",
    defaultMessage: "TC",
  },
  tableColumnPercentagePartner: {
    id: "billingReport.table.column.percentagePartner",
    defaultMessage: "Mg%(-)",
  },
  tableColumnInvoicePartner: {
    id: "billingReport.table.column.invoicePartner",
    defaultMessage: "Fact",
  },
  tableColumnTotalRateInvoice: {
    id: "billingReport.table.column.totalRateInvoice",
    defaultMessage: "Total invoice",
  },
  tableColumnTotalRateMargin: {
    id: "billingReport.table.column.totalRateMargin",
    defaultMessage: "Total margin",
  },
  tableColumnFullConcept: {
    id: "billingReport.table.column.fullConcept",
    defaultMessage: "Comment",
  },
});
